import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconPieChart1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPieChart1"><Path d="M12 2.5V12L20.9594 15.1667" stroke="currentColor"/><Circle cx="12" cy="12" r="9.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconPieChart1;
